import { BookOpen, FileText, Sparkles, Database, CheckCircle } from "lucide-react";
import StatsCard from "@/components/dashboard/StatsCard";
import type { KnowledgeBaseStats as Stats } from "@/api/aiKnowledgeBase";

interface KnowledgeBaseStatsProps {
  stats: Stats | undefined;
  isLoading: boolean;
}

const KnowledgeBaseStats = ({ stats, isLoading }: KnowledgeBaseStatsProps) => {
  if (isLoading || !stats) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className="h-[120px] rounded-lg border bg-card animate-pulse" />
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
      <StatsCard
        title="Total Books"
        value={stats.totalBooks}
        icon={<BookOpen className="h-4 w-4" />}
        description="All book summaries"
      />
      <StatsCard
        title="AI Context Ready"
        value={stats.booksWithAiContext}
        icon={<FileText className="h-4 w-4" />}
        description={`${stats.aiContextCoverage}% coverage`}
      />
      <StatsCard
        title="Embeddings Ready"
        value={stats.booksWithEmbeddings}
        icon={<Sparkles className="h-4 w-4" />}
        description={`${stats.embeddingCoverage}% coverage`}
      />
      <StatsCard
        title="Total Chunks"
        value={stats.totalChunks.toLocaleString()}
        icon={<Database className="h-4 w-4" />}
        description="Embedded text chunks"
      />
      <StatsCard
        title="Fully RAG Ready"
        value={stats.fullyReady}
        icon={<CheckCircle className="h-4 w-4" />}
        description="Context + embeddings complete"
      />
    </div>
  );
};

export default KnowledgeBaseStats;
